<template>
  <div class="login-page">
    <div class="login-stage">
      <div class="login-brand">
        <div class="brand-glow"></div>
        <div class="brand-orb brand-orb-a"></div>
        <div class="brand-orb brand-orb-b"></div>
        <div class="brand-inner">
          <div class="mark">课</div>
          <p class="brand-kicker">Hours Admin</p>
          <h1>课时管理后台</h1>
          <p class="brand-desc">与小程序管理功能一致，可作为小程序不可用时的备用入口。大课与小课分开签到、分开管课时。</p>
          <ul class="brand-points">
            <li>大课：拍照 / 选人签到、接龙</li>
            <li>小课：签到时选择划小课或大课抵，不够记欠</li>
            <li>学员：报名一次，开通或充值即可</li>
          </ul>
        </div>
      </div>

      <div class="login-panel">
        <h2>登录</h2>
        <p class="sub">请填写本馆编码和管理员账号。教练账号也可登录，仅能操作小课签到。</p>
        <el-form :model="form" :rules="rules" ref="form" label-position="top">
          <el-form-item label="俱乐部编码" prop="clubCode">
            <el-input v-model="form.clubCode" placeholder="例如 yuedong" />
          </el-form-item>
          <el-form-item label="账号" prop="username">
            <el-input v-model="form.username" autocomplete="username" placeholder="馆长或教练账号" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              show-password
              autocomplete="current-password"
              @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-button type="primary" class="submit" :loading="loading" @click="handleLogin">进入工作台</el-button>
        </el-form>
        <div class="back-link">
          <router-link to="/">返回公众端</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '../api'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: { clubCode: localStorage.getItem('club_code') || '', username: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const payload = {
            clubCode: (this.form.clubCode || '').trim(),
            username: this.form.username,
            password: this.form.password
          }
          const res = await login(payload)
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('username', res.data.name || res.data.username)
          localStorage.setItem('club_code', res.data.clubCode || payload.clubCode)
          localStorage.setItem('club_name', res.data.clubName || '')
          localStorage.setItem('admin_role', String(res.data.role || 1))
          const role = Number(res.data.role || 1)
          this.$router.push(role === 9 ? '/clubs' : '/dashboard')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(ellipse 70% 60% at 10% 20%, rgba(20, 184, 166, 0.18), transparent 50%),
    radial-gradient(ellipse 50% 50% at 90% 80%, rgba(15, 118, 110, 0.12), transparent 45%),
    linear-gradient(160deg, #F3F1EC 0%, #E8EEE9 100%);
}

.login-stage {
  width: 100%;
  max-width: 920px;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 28px;
  align-items: stretch;
}

.login-brand {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  min-height: 420px;
  color: #fff;
  background: linear-gradient(145deg, #0F1F1C 0%, #16302C 40%, #0F766E 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 36px;
}

.brand-glow {
  position: absolute;
  inset: -20% -10% auto auto;
  width: 70%;
  height: 70%;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.28), transparent 68%);
  pointer-events: none;
}

.brand-orb {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  pointer-events: none;
}

.brand-orb-a {
  width: 180px;
  height: 180px;
  right: -40px;
  bottom: -30px;
  background: rgba(255, 255, 255, 0.04);
}

.brand-orb-b {
  width: 90px;
  height: 90px;
  left: 24px;
  top: 28px;
  background: rgba(20, 184, 166, 0.12);
}

.brand-inner {
  position: relative;
  z-index: 1;
  max-width: 320px;
}

.mark {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
}

.brand-kicker {
  margin: 0 0 8px;
  font-size: 12px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(204, 251, 241, 0.75);
}

.login-brand h1 {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  font-family: var(--aw-display);
  letter-spacing: 1px;
  line-height: 1.25;
}

.brand-desc {
  margin: 14px 0 0;
  font-size: 14px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.78);
}

.brand-points {
  margin: 28px 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 10px;
}

.brand-points li {
  position: relative;
  padding: 10px 12px 10px 28px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  font-size: 13px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.88);
}

.brand-points li::before {
  content: '';
  position: absolute;
  left: 12px;
  top: 50%;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #5EEAD4;
  transform: translateY(-50%);
}

.login-panel {
  background: #fff;
  border: 1px solid var(--aw-line);
  border-radius: 20px;
  padding: 36px 32px;
  box-shadow: var(--aw-shadow);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-panel h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--aw-ink);
}

.sub {
  margin: 8px 0 22px;
  font-size: 13px;
  color: var(--aw-muted);
  line-height: 1.5;
}

.submit {
  width: 100%;
  margin-top: 8px;
  height: 42px;
  font-weight: 600;
}

.back-link {
  text-align: center;
  margin-top: 18px;
  font-size: 13px;
}
.back-link a { color: var(--aw-muted); text-decoration: none; }

@media (max-width: 800px) {
  .login-stage { grid-template-columns: 1fr; }
  .login-brand {
    min-height: 240px;
    padding: 28px 24px;
    align-items: flex-start;
  }
  .login-brand h1 { font-size: 24px; }
  .brand-points { margin-top: 18px; }
}
</style>
